import React from "react";
import { Link } from "react-router-dom";
import { Clock, TrendingUp, MessageCircle } from "lucide-react";

export default function CourseCard({ course }) {
  const price = new Intl.NumberFormat("tr-TR").format(course.price);
  const waText = encodeURIComponent(`Merhaba, "${course.title}" için ücretsiz tanışma dersi almak istiyorum.`);
  return (
    <article
      data-testid={`course-card-${course.slug}`}
      className="card-hover group relative flex flex-col bg-surface border border-white/10 overflow-hidden"
    >
      <Link to={`/egitim/${course.slug}`} className="block relative aspect-[16/10] overflow-hidden">
        <img
          src={course.image_url}
          alt={course.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="absolute top-4 left-4">
          <span className="text-[10px] uppercase tracking-[0.28em] text-gold bg-black/60 px-3 py-1 border border-gold-30">
            {course.category}
          </span>
        </div>
      </Link>

      <div className="p-6 flex-1 flex flex-col">
        <div className="flex items-center gap-4 text-xs text-white/60 mb-3">
          <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-gold" />{course.duration}</span>
          <span className="flex items-center gap-1.5"><TrendingUp className="w-3.5 h-3.5 text-gold" />{course.level}</span>
        </div>
        <Link to={`/egitim/${course.slug}`}>
          <h3 className="font-display text-xl leading-tight text-white group-hover:text-gold transition-colors">
            {course.title}
          </h3>
        </Link>
        <p className="text-sm text-white/60 mt-3 line-clamp-3 flex-1">{course.short_description}</p>

        <div className="hairline my-5" />

        <div className="flex items-end justify-between gap-3">
          <div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-white/50">Yatırım</div>
            <div className="font-display text-2xl text-gold">₺{price}</div>
          </div>
          <div className="flex items-center gap-2">
            <a
              href={`https://wa.me/905543291119?text=${waText}`}
              target="_blank"
              rel="noreferrer"
              data-testid={`course-preview-btn-${course.slug}`}
              className="btn-outline text-xs py-2 px-3"
              title="Ücretsiz tanışma dersi talep et"
            >
              <MessageCircle className="w-3.5 h-3.5" />
            </a>
            <Link
              to={`/kayit-formu?program=${course.slug}`}
              data-testid={`course-buy-btn-${course.slug}`}
              className="btn-primary text-xs py-2 px-4"
            >
              Kayıt Ol
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}
